import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AUDIENCES = [
  {
    badge: "For Individuals",
    color: "#017bef",
    image: "/figma-assets/home/audience-individuals.jpg",
    // The Teams photo sits above the gradient in the design, so only the other three show it
    gradient: true,
    title: "Professionals & Remote Workers",
    description:
      "Access flexible workspaces wherever your work takes you. Hot desks, private offices and meeting rooms — bookable by the hour or the day.",
    cta: "Find a Workspace",
    to: "/work",
  },
  {
    badge: "For Travellers",
    color: "#0062c0",
    image: "/figma-assets/home/audience-travellers.jpg",
    gradient: true,
    title: "Business Travellers",
    description:
      "Book workspace, accommodation and downtime in one place. Arrive prepared, stay comfortable and make the most of your time on the ground.",
    cta: "Plan Your Trip",
    to: "/stay",
  },
  {
    badge: "For Teams",
    color: "#012d6e",
    image: "/figma-assets/home/audience-teams.jpg",
    gradient: false,
    title: "Teams & Businesses",
    description:
      "Give your people flexible access to workspaces and accommodation across Kenya and Ghana. Centralised billing, one dashboard, no back-and-forth.",
    cta: "Explore Enterprise",
    to: "/corporate-page",
  },
  {
    badge: "For Hosts",
    color: "#0ea5e9",
    image: "/figma-assets/home/audience-hosts.jpg",
    gradient: true,
    title: "Space & Venue Partners",
    description:
      "List your space and reach a growing community of professionals, business travellers and enterprise clients across Africa.",
    cta: "List Your Space",
    to: "/partner-signup",
  },
];

export default function AudienceSection() {
  const history = useHistory();

  return (
    <section className="bg-[#f8fbff] py-20">
      <div className="mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">Who It's For</p>
        <h2 className="max-w-[672px] pt-[12px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
          Built for the Way You Work, Travel and Live
        </h2>

        <div className="grid grid-cols-1 gap-[20px] pt-12 md:grid-cols-2">
          {AUDIENCES.map(audience => (
            <div
              key={audience.title}
              className="overflow-hidden rounded-3xl border-[1px] border-solid border-[#e5e7eb] bg-white"
            >
              <div className="relative h-52">
                <img src={audience.image} alt={audience.title} className="absolute inset-0 size-full object-cover" />
                {audience.gradient && (
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                )}
                <span
                  className="absolute left-[16px] top-[16px] rounded-full px-[12px] py-1 text-[12px] font-semibold leading-4 text-white"
                  style={{ backgroundColor: audience.color }}
                >
                  {audience.badge}
                </span>
              </div>
              <div className="p-7">
                <h3 className="text-[20px] font-bold leading-[27.5px] text-[#0a0a0a]">{audience.title}</h3>
                <p className="pb-[20px] pt-[12px] text-[14px] leading-[22.75px] text-[#717182]">
                  {audience.description}
                </p>
                <button
                  type="button"
                  onClick={() => history.push(audience.to)}
                  className="inline-flex items-center gap-2 text-[14px] font-semibold leading-5 hover:underline"
                  style={{ color: audience.color }}
                >
                  {audience.cta}
                  <ArrowRight className="size-[15px]" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
